export default from './inputParams.js'